<div class="agentix-trial-signup">
  <agentix-trial-marketing-panel [activeSlide]="activeMarketingSlide"></agentix-trial-marketing-panel>

  <section class="agentix-trial-signup__panel">

    <div class="agentix-trial-signup__content">
      @if (currentStep === 'email') {
      <button type="button"
              class="agentix-trial-signup__back-link agentix-trial-signup__back-link--top"
              (click)="goBack()">
        <mat-icon svgIcon="arrow-back-left"
                  aria-hidden="true"></mat-icon>
        {{ 'back' | translate }}
      </button>
      }
      <header class="agentix-trial-signup__header">
        <agentix-trial-signup-brand></agentix-trial-signup-brand>
      </header>

      @switch (currentStep) {
      @case ('email') {
      <div class="agentix-trial-signup__step">
        <div class="agentix-trial-signup__intro">
          <h1>{{ 'agentix_trial_signup_email_title' | translate }}</h1>
          <p class="agentix-trial-signup__intro-lead">{{ 'agentix_trial_signup_email_title2' | translate }}</p>
          <p class="agentix-trial-signup__intro-subtitle">{{ 'agentix_trial_signup_email_subtitle' | translate }}</p>
        </div>

        <form [formGroup]="emailForm"
              class="agentix-trial-signup__form"
              novalidate>
          <div class="agentix-trial-signup__field">
            <label for="agentix-trial-email">{{ 'agentix_trial_signup_business_email_label' | translate }}</label>
            <div class="agentix-trial-signup__input-wrap">
              <mat-icon class="agentix-trial-signup__input-icon"
                        svgIcon="email-provider"
                        aria-hidden="true"></mat-icon>
              <xa-text id="agentix-trial-email"
                       formControlName="email"
                       [required]="true"
                       placeholder="{{ 'agentix_trial_signup_email_placeholder' | translate }}">
              </xa-text>
            </div>
            @if (getFieldError(emailForm, 'email')) {
            <p class="agentix-trial-signup__field-error">{{ getFieldError(emailForm, 'email') }}</p>
            }
          </div>

          <xa-button class="agentix-trial-signup__primary-btn"
                     [disabled]="disableEmailSubmit"
                     (click)="sendCode()"
                     (keydown.enter)="sendCode()">
            {{ 'agentix_trial_signup_send_code' | translate }}
          </xa-button>

          <p class="agentix-trial-signup__sign-in">
            {{ 'agentix_trial_signup_already_have_account' | translate }}
            <span class="agentix-trial-signup__link"
                  (click)="signIn()">
              {{ 'agentix_trial_signup_sign_in' | translate }}
            </span>
          </p>
        </form>
      </div>
      }
      @case ('verifyOtp') {
      <div class="agentix-trial-signup__step">
        <div class="agentix-trial-signup__intro">
          <h1>{{ 'agentix_trial_signup_verify_title' | translate }}</h1>
          <p>{{ 'agentix_trial_signup_verify_subtitle' | translate: { digits: otpConfig.length } }}</p>
          <p class="masked-email">{{ maskedEmail }}</p>
        </div>

        <div class="agentix-trial-signup__otp-block">
          <label for="agentix-trial-otp">{{ 'agentix_trial_signup_otp_label' | translate }}</label>
          <ng-otp-input [config]="otpConfig"
                        (onInputChange)="onOtpChange($any($event))"></ng-otp-input>
          @if (otpError) {
          <p class="agentix-trial-signup__field-error">{{ otpError }}</p>
          }

          <div class="agentix-trial-signup__otp-meta">
            <span class="agentix-trial-signup__timer">
              <mat-icon aria-hidden="true">access_time</mat-icon>
              {{ formattedResendCounter }}
            </span>
            <button type="button"
                    class="agentix-trial-signup__link"
                    [disabled]="resendCounter > 0"
                    (click)="resendCode()">
              {{ 'agentix_trial_signup_resend_code' | translate }}
            </button>
          </div>
        </div>

        <xa-button class="agentix-trial-signup__primary-btn"
                   [disabled]="disableOtpSubmit"
                   (click)="verifyOtp()"
                   (keydown.enter)="verifyOtp()">
          {{ 'verify' | translate }}
        </xa-button>

        <button type="button"
                class="agentix-trial-signup__back-link"
                (click)="backToSignup()">
          <mat-icon svgIcon="arrow-back-left"
                    aria-hidden="true"></mat-icon>
          {{ 'agentix_trial_signup_back_to_signup' | translate }}
        </button>
      </div>
      }
      @case ('verified') {
      <div class="agentix-trial-signup__step agentix-trial-signup__step--centered">
        <div class="agentix-trial-signup__success-icon"
             aria-hidden="true">
          <mat-icon svgIcon="check-circle-filled"></mat-icon>
        </div>
        <div class="agentix-trial-signup__intro agentix-trial-signup__intro--centered">
          <h1>{{ 'agentix_trial_signup_verified_title' | translate }}</h1>
          <p>{{ 'agentix_trial_signup_verified_subtitle' | translate }}</p>
        </div>

        <xa-button class="agentix-trial-signup__primary-btn"
                   (click)="continueToProfile()"
                   (keydown.enter)="continueToProfile()">
          {{ 'continue' | translate }}
        </xa-button>

        <button type="button"
                class="agentix-trial-signup__text-link"
                (click)="changeEmail()">
          {{ 'agentix_trial_signup_change_email' | translate }}
        </button>
      </div>
      }
      @case ('profile') {
      <div class="agentix-trial-signup__step">
        <div class="agentix-trial-signup__intro">
          <h1>{{ 'agentix_trial_signup_profile_title' | translate }}</h1>
          <p>{{ 'agentix_trial_signup_profile_subtitle' | translate }}</p>
        </div>

        <form [formGroup]="profileForm"
              class="agentix-trial-signup__form"
              novalidate>
          <div class="agentix-trial-signup__field">
            <xa-text formControlName="fullName"
                     [required]="true"
                     label="{{ 'agentix_trial_signup_full_name_label' | translate }}"
                     placeholder="{{ 'agentix_trial_signup_full_name_placeholder' | translate }}">
            </xa-text>
            @if (getFieldError(profileForm, 'fullName')) {
            <p class="agentix-trial-signup__field-error">{{ getFieldError(profileForm, 'fullName') }}</p>
            }
          </div>

          <div class="agentix-trial-signup__field">
            <xa-text formControlName="organization"
                     [required]="true"
                     label="{{ 'organization' | translate }}"
                     placeholder="{{ 'agentix_trial_signup_organization_placeholder' | translate }}">
            </xa-text>
            @if (getFieldError(profileForm, 'organization')) {
            <p class="agentix-trial-signup__field-error">{{ getFieldError(profileForm, 'organization') }}</p>
            }
          </div>

          <div class="agentix-trial-signup__field">
            <xa-select [config]="industryConfig"
                       [options]="industryOptions"
                       formControlName="industryId">
            </xa-select>
            @if (getFieldError(profileForm, 'industryId')) {
            <p class="agentix-trial-signup__field-error">{{ getFieldError(profileForm, 'industryId') }}</p>
            }
          </div>

          <div class="agentix-trial-signup__field">
            <xa-select [config]="countryConfig"
                       [options]="countryOptions"
                       formControlName="country">
            </xa-select>
            @if (getFieldError(profileForm, 'country')) {
            <p class="agentix-trial-signup__field-error">{{ getFieldError(profileForm, 'country') }}</p>
            }
          </div>

          <div class="agentix-trial-signup__field">
            <div class="agentix-trial-signup__phone-row">
              <xa-select class="agentix-trial-signup__country-code"
                         [config]="countryCodeConfig"
                         [options]="countryCodeOptions"
                         formControlName="countryCode">
              </xa-select>
              <xa-tel class="agentix-trial-signup__phone-number"
                      formControlName="phoneNumber"
                      label="{{ 'mobile_number' | translate }}"
                      [placeholder]="phonePlaceholder">
              </xa-tel>
            </div>
            @if (getFieldError(profileForm, 'phoneNumber')) {
            <p class="agentix-trial-signup__field-error">{{ getFieldError(profileForm, 'phoneNumber') }}</p>
            }
          </div>

          <xa-button class="agentix-trial-signup__primary-btn"
                     [disabled]="disableProfileSubmit"
                     (click)="saveProfile()"
                     (keydown.enter)="saveProfile()">
            {{ 'save' | translate }}
          </xa-button>
        </form>
      </div>
      }
      @case ('confirmation') {
      <div class="agentix-trial-signup__step agentix-trial-signup__step--centered">
        <div class="agentix-trial-signup__envelope"
             aria-hidden="true">
          <div class="agentix-trial-signup__envelope-circle">
            <img src="assets/img/ai/email-success-sent.gif"
                 alt="email-success-sent" />
          </div>
        </div>
        <div class="agentix-trial-signup__intro agentix-trial-signup__intro--centered">
          <h1>{{ 'agentix_trial_signup_confirmation_title' | translate }}</h1>
          <p>{{ 'agentix_trial_signup_confirmation_subtitle' | translate:{ email: email } }}</p>
        </div>

        <xa-button class="agentix-trial-signup__primary-btn"
                   (click)="getStarted()"
                   (keydown.enter)="getStarted()">
          {{ 'agentix_trial_signup_get_started' | translate }}
        </xa-button>
      </div>
      }
      }
    </div>

    <footer class="agentix-trial-signup__footer">
      {{ 'agentix_trial_signup_copyright' | translate }}
    </footer>
  </section>
</div>